import MatchPlayStatusBar from './match-play-status-bar'

export default MatchPlayStatusBar
